class LocalizeByGPSError extends Error {
  constructor(message = 'Unknown GPS localization error') {
    super(message);
    this.name = "LocalizeByGPSError";
    this.message = message;
  }
}

export default LocalizeByGPSError;